import {HoverMenu, HoverMenuItem} from "components/hover-menu"
import {memo, PropTypes, propTypesExact, ShapeComponent, shapeComponent, useI18n, View} from "shared/base"
import DeleteModal from "components/school-classes/delete-modal"
import EditSchoolClassRoleModal from "routes/user/dashboard/edit-school-class-role-modal"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import Modal from "components/modal"
import PlansSignUpModal from "components/plans/sign-up-modal"
import React from "react"
import Routes from "shared/routes"
import {SchoolClass} from "models"
import SchoolClassesInviteForm from "components/school-class-roles/invite-form"

export default memo(shapeComponent(class OptionsButton extends ShapeComponent {
  static propTypes = propTypesExact({
    onShowSchoolClassRolesModal: PropTypes.func.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.components.school_classes.admin_card"})

    this.setInstance({t})
    this.useStates({
      showAddTeacherModal: false,
      showDeleteClassModal: false,
      showNewRoleModal: false,
      showSignUpModal: false
    })
  }

  render() {
    const {schoolClass} = this.p

    return (
      <>
        {this.s.showAddTeacherModal &&
          <EditSchoolClassRoleModal onRequestClose={this.tt.onRequestCloseAddTeacherModal} schoolClass={schoolClass} />
        }
        {this.s.showDeleteClassModal &&
          <DeleteModal onRequestClose={this.tt.onRequestCloseDeleteModal} schoolClass={schoolClass} />
        }
        {this.s.showSignUpModal &&
          <PlansSignUpModal onRequestClose={this.tt.onRequestClosePlansSignUpModal} schoolClass={schoolClass} />
        }
        {this.s.showNewRoleModal &&
          <Modal className="send-invitation-modal" onRequestClose={this.tt.onRequestCloseNewRoleModal}>
            <SchoolClassesInviteForm onInviteSent={this.tt.onInviteSent} schoolClass={schoolClass} />
          </Modal>
        }
        <HoverMenu content={this.tt.hoverMenuContent}>
          <View style={this.iconViewStyle ||= {padding: 12}}>
            <Icon
              dataSet={this.iconDataSet ||= {class: "school-classes--options-button", schoolClassId: schoolClass.id()}}
              name="ellipsis-vertical"
              size={22}
              version="FontAwesome6"
            />
          </View>
        </HoverMenu>
      </>
    )
  }

  hoverMenuContent = () => {
    const {t} = this.tt
    const {schoolClass} = this.p

    return (
      <>
        {schoolClass.can("edit") &&
          <HoverMenuItem
            dataSet={this.editSchoolClassOptionDataSet ||= {class: "edit-school-class-option"}}
            label={t(".edit")}
            to={Routes.editUserSchoolClassPath(schoolClass.id())}
          />
        }
        <HoverMenuItem label={t(".go_to_woof_space")} target="_blank" to={Routes.userSchoolClassClassSpacePath(schoolClass.id())} />
        <HoverMenuItem label={t(".go_to_analysis")} to={Routes.userUnicornPath({school_classes: [schoolClass.id()]})} />
        <HoverMenuItem
          dataSet={this.addTeacherOptionDataSet ||= {class: "add-teacher-option"}}
          label={t(".add_teacher")}
          onPress={this.tt.onAddTeacherPress}
        />
        <HoverMenuItem
          dataSet={this.editUsersDataSet ||= {class: "edit-users-option"}}
          label={t(".edit_users")}
          onPress={this.tt.onShowSchoolClassRolesModal}
        />
        <HoverMenuItem
          dataSet={this.upgradeToPaidLicenseDataSet ||= {class: "upgrade-to-paid-license-option"}}
          label={t(".upgrade_to_paid_license")}
          onPress={this.tt.onUpgradeToPaidLicenseClicked}
        />
        {schoolClass.can("softDelete") &&
          <HoverMenuItem
            dataSet={this.deleteSchoolClassOptionDataSet ||= {class: "delete-school-class-option"}}
            label={t(".delete_class")}
            onPress={this.tt.onDeleteSchoolClassPressed}
          />
        }
      </>
    )
  }

  onAddTeacherPress = () => this.setState({showAddTeacherModal: true})
  onDeleteSchoolClassPressed = () => this.setState({showDeleteClassModal: true})
  onInviteSent = () => this.setState({showNewRoleModal: false})
  onRequestCloseAddTeacherModal = () => this.setState({showAddTeacherModal: false})
  onRequestCloseDeleteModal = () => this.setState({showDeleteClassModal: false})
  onRequestCloseNewRoleModal = () => this.setState({showNewRoleModal: false})
  onRequestClosePlansSignUpModal = () => this.setState({showSignUpModal: false})
  onShowSchoolClassRolesModal = () => this.p.onShowSchoolClassRolesModal({schoolClass: this.p.schoolClass})
  onUpgradeToPaidLicenseClicked = () => this.setState({showSignUpModal: true})
}))
